export function walkStrings<T = unknown>(data: T, cb: (value: string) => string): T {
    if (!data) return data;

    if (typeof data === 'string') {
        return cb(data) as T;
    }
    if (Array.isArray(data)) {
        return data.map((value: unknown) => walkStrings(value, cb)) as T;
    }
    if (typeof data === 'object') {
        const result: Record<string, unknown> = {};
        for (const key in data) {
            result[key] = walkStrings((data as Record<string, unknown>)[key], cb);
        }
        return result as T;
    }
    return data;
}
